import { bookingStore } from 'entities/booking';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckedItemsList, TCheckedItem } from 'shared/ui/checkedItems';
import { withPreloader } from 'shared/ui/preloader';
import { ClinicsWrapper } from './clinicsWrapper';
import { BookingClinic } from 'entities/booking/store/types';
import { clinicsStore } from 'entities/clinics/store/store';
import { ClinicState } from 'entities/clinics/store/types';
import { ClinicsSearch } from '../clinicsSearch/clinicsSearch';
import { ClinicCounterButton } from '../clinicCounterButton/clinicCounterButton';
import {
	bookingClinicsMap,
	clinicsMap,
} from 'entities/clinics/lib/helpers/clinicsMap';
import styles from './styles.module.scss';

const CheckedClinicsItems = withPreloader(ClinicsWrapper);
export const ClinicSelection = observer(() => {
	const [clinics, setClinics] = useState<ClinicState[]>(clinicsStore.clinics);
	const [selectedClinics, setSelectedClinic] = useState<BookingClinic[]>([]);
	const navigate = useNavigate();

	useEffect(() => {
		clinicsStore.fetchClinics();
	}, []);

	const mapCheckedItemToClinic = (item: TCheckedItem): BookingClinic => {
		return {
			id: item.id,
			name: item.name,
		};
	};

	useEffect(() => {
		if (bookingStore.clinics.length) {
			const map = bookingClinicsMap();
			setSelectedClinic(map);
		}
	}, []);

	const selectClinic = (checkedItem: TCheckedItem, isChecked: boolean) => {
		const clinic = mapCheckedItemToClinic(checkedItem);
		if (isChecked) {
			setSelectedClinic(prevClinic =>
				Array.from(new Set([...prevClinic, clinic])),
			);
		} else {
			setSelectedClinic(prevClinics =>
				prevClinics.filter(prevClinic => prevClinic.id !== clinic.id),
			);
		}
	};

	useEffect(() => {
		if (selectedClinics) {
			bookingStore.setClinics(selectedClinics);
		}
	}, [selectedClinics]);

	const selectClinics = async () => {
    const url = bookingStore.redirectFromDoctorPage || '/doctors-selection';
    bookingStore.setRedirectFromDoctorPage(null);
		navigate(url);
	};

	const updateClinics = (newClinics: ClinicState[]) => {
		setClinics(newClinics);
	};

	return (
		<div className={styles['clinics-list']}>
			<div className="mb-2">
				<ClinicsSearch updateClinics={updateClinics} />
			</div>
			<CheckedClinicsItems
				isLoading={clinicsStore.loading}
				error={clinicsStore.error}
			>
				{clinics.length > 0 ? (
					<CheckedItemsList
						items={clinicsMap(clinics)}
						onSelectItem={selectClinic}
						checkedItemsIds={bookingStore.clinics.map(
							clinic => clinic.id,
						)}
					/>
				) : (
					'результаты не найдены'
				)}
			</CheckedClinicsItems>
			<ClinicCounterButton
				selectedClinics={selectedClinics}
				selectClinics={selectClinics}
			/>
		</div>
	);
});
